// todo: It has to be refactor
// the source for this file is profile-menu.js

(function ($, UX) {
    var $body = $('body'),
        isMobile = false; // variable use to determine if responsive mode is on or off

    var collapsibleMenu = {
        cName: '',
        cNameRes: '',
        $target: null,
        $toggle: null,
        $ul: null,
        $li: null,
        vPort: 'screen-md', // default responsive break point

        init: function () {
            (collapsibleMenu.cName = 'collapsible-menu'),
                (collapsibleMenu.cNameRes = collapsibleMenu.cName + '--res'),
                (collapsibleMenu.$target = $('[data-collapsible-id]')),
                collapsibleMenu.$target.addClass(collapsibleMenu.cName),
                (collapsibleMenu.id = collapsibleMenu.$target.data('collapsible-id'));

            collapsibleMenu.on.dropdownDestroy(collapsibleMenu.$target);
            collapsibleMenu.on.build();
            collapsibleMenu.control();
        },
        control: function () {
            $body.on('click', '.collapsible-menu--res a', function (e) {
                collapsibleMenu.on.select.dropdown($(this));
            });

            $(document).on(collapsibleMenu.vPort + '-on', function () {
                // Waiting for custom event that will be triggered by controller.js to activate responsive effects
                isMobile = true;
                $('.collapsible-menu').addClass(collapsibleMenu.cNameRes); // class will be used in our scss (to replace media queries)
                collapsibleMenu.on.build();
            });

            $(document).on(collapsibleMenu.vPort + '-off', function () {
                // Waiting for custom event that will be triggered by controller.js to deactivate responsive effects
                isMobile = false;
                $('.collapsible-menu').removeClass(collapsibleMenu.cNameRes);
                collapsibleMenu.on.build();
            });
        },
        on: {
            select: {
                dropdown: function (elem) {
                    let dropdownContainer;
                    var dataAttr = elem.closest('ul').data('mobile-toggle');
                    if (dataAttr === 'dropdown' || elem.closest('ul').hasClass('dropblock--tab')) {
                        dropdownContainer = elem.closest('.dropBlock');
                        dropdownContainer.children('a').find('span').text(elem.text());
                    }
                },
            },
            dropdownBuild: function (elem) {
                // rebuild tabs to be as drop down
                let $dropdownContainer, $activeTab;
                if (UX.dropBlock) {
                    UX.dropBlock.init();
                }
                elem.wrap(
                    '<div class="' +
                        collapsibleMenu.cName +
                        '--dropBlock" data-db-parent-of="dbTab-collapsible-menu"></div>'
                );
                $dropdownContainer = elem.closest('.' + collapsibleMenu.cName + '--dropBlock');
                $activeTab = collapsibleMenu.get.activeTab(elem);
                let activevalue = 'Select';
                if ($activeTab.text().length > 0) {
                    activevalue = $activeTab.text();
                }
                if ($('.issue-navigator__link').text().length > 0) {
                    activevalue = $('.issue-navigator__link').text();
                }
                $dropdownContainer.prepend(
                    '<a href="#" data-db-target-for="dbTab-' +
                        collapsibleMenu.cName +
                        '"><span>' +
                        activevalue +
                        '</span><i class="icon-chevron-down" aria-hidden="true"></i></a>'
                );
                elem.attr('data-db-target-of', 'dbTab-' + collapsibleMenu.cName);
            },
            dropdownDestroy: function (elem) {
                // return tabs to default
                var dropdownContainer = elem.closest('.' + collapsibleMenu.cName + '--dropBlock');
                dropdownContainer.children('a').remove();
                elem.removeAttr('data-db-target-of')
                    .removeClass('js--open')
                    .removeAttr('style')
                    .unwrap('.' + collapsibleMenu.cName + '--dropBlock');
            },
            build: function () {
                if (isMobile) {
                    collapsibleMenu.on.dropdownBuild(collapsibleMenu.$target);
                } else {
                    collapsibleMenu.on.dropdownDestroy(collapsibleMenu.$target);
                }
            },
        },
        get: {
            activeTab: function (elem) {
                return elem.find('a.active');
            },
        },
    };

    UX.collapsibleMenu = collapsibleMenu;
    $(document).ready(UX.collapsibleMenu.init);
})(jQuery, UX);
